var map = {
	"./matching-process.png": 4390,
	"./raise-add-job.png": 18272,
	"./raise-add-shift.png": 8393,
	"./raise-finding-candidates.png": 96772,
	"./raise-get-started-cover.png": 56883,
	"./raise-job-get-started-cover.png": 76208,
	"./raise-select-worker.png": 85674,
	"./raise-shift-timeline.png": 92613,
	"./raise-show-help.png": 40585,
	"./raise-sign-off.png": 95618,
	"./raise-unlock-full-profile.png": 90942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51554;